module.exports = __webpack_public_path__ + "assets/img/em_toggle_p1.a3b596d.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/em_toggle_p1.png
// module id = 4O7U
// module chunks = 0